import { useEffect } from "react";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import About from "./About";
import AdminPage from "./AdminPage";
import AvatarDetail from "./AvatarDetail";
import AvatarForm from "./AvatarForm";
import AvatarList from "./AvatarList";
import Exhibits from "./Exhibits";
import ImacDesktopShell from "./exhibits/imac-g3/ImacDesktopShell";
import EchoDotShell from "./exhibits/werkschau/echo/EchoShell";
import IPodDesktopShell from "./exhibits/werkschau/ipod/IPodDesktopShell";
import StoryExploration from "./exhibits/werkschau/stories/StoryExploration";
import StorySharing from "./exhibits/werkschau/stories/StorySharing";
import CassetteTapeShell from "./exhibits/werkschau/tape/CassetteTapeShell";
import WerkschauSelector from "./exhibits/werkschau/WerkschauSelector";
import InterfaceMuseum from "./InterfaceMuseum";
import MemoryRecorder from "./MemoryRecorder";
import Placeholder from "./Placeholder";
import SandboxTest from "./Sandbox";
import UICards from "./UICards";
import Win98Theme from "./Win98Theme";

function KioskKeyLoader() {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const key = searchParams.get("kioskKey");
    if (key) {
      localStorage.setItem("kiosk_token", key);
    }
  }, [searchParams]);
  return null;
}

function AppRoutes() {
  return (
    <>
      <KioskKeyLoader />
      <Routes>
        <Route path="/" element={<Placeholder />} />
        <Route path="/exhibits" element={<Exhibits />} />
        <Route path="/exhibits/ui-cards" element={<UICards />} />
        <Route path="/exhibits/ui-cards/:id" element={<UICards />} />
        <Route path="/exhibits/memory-recorder" element={<MemoryRecorder />} />
        <Route path="/exhibits/win98-theme" element={<Win98Theme />} />
        <Route
          path="/exhibits/interface-museum"
          element={<InterfaceMuseum />}
        />
        <Route path="/exhibits/vcfzh25" element={<AvatarList />} />
        <Route path="/exhibits/vcfzh25/new" element={<AvatarForm />} />
        <Route
          path="/exhibits/vcfzh25/detail/:uuid"
          element={<AvatarDetail />}
        />

        <Route path="/playground" element={<SandboxTest />} />
        <Route path="/admin" element={<AdminPage />} />

        <Route
          path="/exhibits/imac"
          element={<Navigate to="/exhibits/imac/welcome" replace />}
        />
        <Route
          path="/exhibits/imac/:windowType"
          element={<ImacDesktopShell />}
        />
        <Route
          path="/exhibits/imac/share-story"
          element={<StorySharing exhibitionId={4} />}
        />
        <Route
          path="/exhibits/imac/explore-stories"
          element={<StoryExploration exhibitionId={4} />}
        />

        <Route path="/exhibits/werkschau" element={<WerkschauSelector />} />
        <Route
          path="/exhibits/werkschau/tape"
          element={<CassetteTapeShell />}
        />
        <Route path="/exhibits/werkschau/ipod" element={<IPodDesktopShell />} />
        <Route path="/exhibits/werkschau/echo" element={<EchoDotShell />} />

        <Route
          path="/exhibits/werkschau/share-story"
          element={<StorySharing exhibitionId={1} />}
        />

        <Route
          path="/exhibits/werkschau/explore-stories"
          element={<StoryExploration exhibitionId={1} />}
        />

        <Route path="/about" element={<About />} />
      </Routes>
    </>
  );
}

export default AppRoutes;
